import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faXmark } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { IActionButton } from "ui/model"
import { getPopupContentId } from "ui/tools/popup"
import { FlexBox } from "./FlexBox"
import { PopupTitle } from "./PopupTitle"

interface IPopupProps {
  id: string
  title: string
  children: any
  icon?: IconDefinition
  sx?: any
  displayCloseIcon?: boolean
  displayCloseButton?: boolean
  backgroundColor?: string
  minWidth?: string
  maxWidth?: string
  actionButtons?: IActionButton[]
  onClose(origin: "button" | "outside-click"): any
}

interface IPopupConnectProps {
  containerWidth: number
}

class PopupCmp extends React.PureComponent<IPopupProps & IPopupConnectProps, {}> {
  public render() {
    return (
      <Dialog
        fullScreen={false}
        open={true}
        onClose={() => this.props.onClose("outside-click")}
        aria-labelledby={this.props.id}
        sx={{
          "& .MuiDialogContent-root": {
            paddingTop: 0
          },
          "& .MuiPaper-root.MuiDialog-paper": {
            minWidth: this.props.minWidth ? this.props.minWidth : undefined,
            maxWidth: this.props.maxWidth ? this.props.maxWidth : this.props.maxWidth === "" ? undefined : "37.5rem",
            backgroundColor: this.props.backgroundColor
              ? this.props.backgroundColor
              : theme => theme.palette.background.default
          },
          ...this.props.sx
        }}>
        <DialogTitle
          sx={{
            minWidth:
              this.props.containerWidth > 560 ? (this.props.minWidth ? this.props.minWidth : "30rem") : undefined
          }}
          id={this.props.id}>
          <FlexBox
            jc="space-between"
            ai="flex-start"
            sx={{
              "color": theme => theme.palette.text.primary2,
              "& .close-icon": { cursor: "pointer", color: theme => theme.palette.text.primary },
              "& .close-icon:hover": {
                color: theme => theme.palette.primary.main,
                transition: "color 400ms ease",
                fontWeight: "600"
              }
            }}>
            <PopupTitle
              id={`${this.props.id}-title`}
              icon={this.props.icon}
              title={this.props.title}
              actionButtons={this.props.actionButtons}
            />
            {this.props.displayCloseIcon && (
              <FlexBox>
                <FontAwesomeIcon
                  id={`${this.props.id}-close-button`}
                  className="close-icon"
                  icon={faXmark}
                  onClick={() => this.props.onClose("button")}
                />
              </FlexBox>
            )}
          </FlexBox>
        </DialogTitle>
        <DialogContent id={getPopupContentId(this.props.id)}>{this.props.children}</DialogContent>
        {this.props.displayCloseButton && (
          <DialogActions sx={{ paddingRight: "1rem", paddingBottom: "1rem" }}>
            <Button
              autoFocus
              onClick={() => this.props.onClose("button")}
              variant="contained"
              sx={{ backgroundColor: theme => theme.palette.primary.main }}>
              {translate("button.close")}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

export const Popup = connect<IPopupConnectProps, IPopupConnectProps, IPopupProps, IRootState>(
  (state: IRootState): IPopupConnectProps => ({
    containerWidth: state.ui.container.width
  })
)(PopupCmp)
